import { MaintenanceRequestPriority } from '../../_types/resident'

const PRIORITY_OPTIONS: MaintenanceRequestPriority[] = [
  'low',
  'normal',
  'high',
  'emergency',
]

const MAX_MAINTENANCE_IMAGES = 6

export { PRIORITY_OPTIONS, MAX_MAINTENANCE_IMAGES }
